import { Add } from '@app/ui/iconComponents';
import { FC } from 'react';
import { ClearIndicatorProps } from 'react-select';
import styled from 'styled-components';

const ClearIndicator: FC<ClearIndicatorProps> = ({
  innerProps: { ref, ...restInnerProps },
}) => {
  return (
    <div {...restInnerProps} ref={ref}>
      <div>
        <StyledAdd width={16} height={16} />
      </div>
    </div>
  );
};

const StyledAdd = styled(Add)`
  transform: rotate(45deg);
`;

export default ClearIndicator;
